
$soupmail.modal = {
	
	enabled : true,
	
	error : function($error, $heading) {
		$soupmail.testFailure(($heading ? ($heading + ': ') : '') + $error);
		return $soupmail.modal.raise($error, $heading, 'error');
	},
	
	notice : function($notice, $heading) {
		if (!$heading) { $heading = 'Warning'; }
		return $soupmail.modal.raise($notice, $heading, 'notice');
	},
	
	message : function($message, $heading) {
		if (!$heading) { $heading = 'Message'; }
		return $soupmail.modal.raise($message, $heading, 'message');
	},
	
	terms : function($heading, $html) {
		var $messageId = $soupmail.modal.raise($html, $heading, 'terms');
		jQuery('#'+$messageId+' .raise-buttons').append('<a href="#" class="button-print" style="float:right">Print</a>');
		jQuery('#'+$messageId+' .button-print').click(function() {
			window.print();
		});
		return $messageId;
	},
	
	question : function($question, $okButton, $extraButton, $cancelButton) {
		if (!$okButton) {
			$okButton = {cssClass:'button-ok', labelText:'Ok'};
		}
		if (typeof($okButton) == 'function') {
			$okButton = {cssClass:'button-ok', labelText:'Ok', clickEvent:$okButton};
		}
		if (!$cancelButton) {
			$cancelButton = {cssClass:'button-cancel', labelText:'Cancel'};
		}
		if ($config.mobile) {
			if (confirm($question)) { $okButton.clickEvent(); }
		} else {
			$messageId = $soupmail.modal.raise($question, 'Confirm decision', 'confirm');
			if ($cancelButton) {
				jQuery('#'+$messageId+' .raise-buttons a').text($cancelButton.labelText).addClass($cancelButton.cssClass);
			}
			if ($extraButton) {
				jQuery('#'+$messageId+' .raise-buttons').prepend('<a href="#" class="'+$extraButton.cssClass+'">'+$extraButton.labelText+'</a>');
				jQuery('#'+$messageId+' .'+$extraButton.cssClass).click(function() {
					jQuery('#'+$messageId+' .'+$cancelButton.cssClass).click();
					$extraButton.clickEvent();
				});
			}
			if ($okButton) {
				jQuery('#'+$messageId+' .raise-buttons').prepend('<a href="#" class="'+$okButton.cssClass+'">'+$okButton.labelText+'</a>');
				jQuery('#'+$messageId+' .'+$okButton.cssClass).click(function() {
					jQuery('#'+$messageId+' .'+$cancelButton.cssClass).click();
					$okButton.clickEvent();
				});
			}
			return $messageId;
		}
	},
	
	deletion : function($question, $callback) {
		var $messageId = $soupmail.modal.raise($question, 'Confirm deletion', 'confirm');
		jQuery('#'+$messageId+' .raise-buttons a').text('Cancel').addClass('button-cancel');
		jQuery('#'+$messageId+' .raise-buttons').prepend('<a href="#" class="button-ok button-red">Delete</a>');
		jQuery('#'+$messageId+' .button-ok').click(function() {
			jQuery('#'+$messageId+' .button-cancel').click();
			$callback();
		});
		return $messageId;
	},
	
	apiError : function($apiErrors) {
		var $errorMessage = '';
		jQuery.each($apiErrors, function($key, $messages) {
			jQuery.each($messages, function($k, $message) {
				$errorMessage += $soupmail.string.ucfirst($key) + ' ' + $message + '<br />';
			});
		});
		$soupmail.modal.raise($errorMessage);
	},
	
	raise : function($error, $customMessage, $type) {
		
		if (!$soupmail.modal.enabled) {
			return false;
		}
		if ($type == null) {
			$type = 'error';
		}
		if ($customMessage == null) {
			$customMessage = $soupmail.string.ucfirst($type);
		}
		if ($config.mobile) {
			return alert($customMessage + ':' + "\r\n" + $error);
		}
		
		var $errorId = 'standalone_error_' + parseInt(Math.random() * 10000);
		var $errorIdSelector = '#' + $errorId;
		var $html = '<div class="raise-header"><h2>'+$customMessage+'</h2></div><p>'+$error+'</p>';
		
		$views.all.scrollToTop();
		jQuery('html, body').addClass('overflowHidden').addClass('soupmail-modal-active');
		jQuery('.fullscreen_error_bg').remove();
		jQuery('body').prepend('<div class="fullscreen_error_bg"></div>');
		jQuery('body').prepend('<div id="'+$errorId+'" class="fullscreen_error_fg fullscreen_popup_'+$type+'">'+$html+'<div class="raise-buttons"><a href="#">Ok</a><div class="clear"></div></div></div>');
		jQuery($errorIdSelector + ' .raise-buttons a, .steps .ok, .steps .warn').click(function(e) {
			e.preventDefault();
			if (jQuery('.fullscreen_error_fg').size() == 1) {
				jQuery('html, body').removeClass('overflowHidden').removeClass('soupmail-modal-active');
				jQuery('.fullscreen_error_bg').remove();
			}
			jQuery(this).parent().parent().remove();
			if (jQuery(this).hasClass('warn')){
				$controllers.mailboxsettings.displayFromHelp();
			}
		});
		
		return $errorId;
		
	},
	
	remove : function() {
		jQuery('#popup-message-container, #system-message-container').html('');
	},
	
	help_save_email : function() {
		var $html = '<div class="steps">';
		$html += '<div class="step-1-3"><img src="images/save-emails-help-step-1.png" alt="save-emails-help-step-1" width="136" height="136" /><br /><div class="step-title">1</div><div class="step-desc"><strong>Select email</strong><br/>in your email client.</div></div>';
		$html += '<div class="step-2"><img src="images/save-emails-help-step-2.png" alt="save-emails-help-step-2" width="230" height="136" /><br /><div class="step-title">2</div><div class="step-desc"><strong>Move email</strong><br/>into your Soup Mail folder.</div></div>';
		$html += '<div class="step-1-3"><img src="images/save-emails-help-step-3.png" alt="save-emails-help-step-3" width="136" height="136" /><br /><div class="step-title">3</div><div class="step-desc"><strong>Soup Mail does the rest</strong><br/>your email will be synced shortly.</div></div>';
		$html += '<div class="outlook-download">Use <strong>Microsoft Outlook</strong>? With the Soup Mail Add-In file your emails with one click. <a target="_blank" href="https://go.soupmail.com/outlook-addin" class="download">Download Now</a></div>';
		if (!jQuery('#help .connect-mailbox').hasClass('done')){
			$html += "<a href='#' class='warn'>Connect your Mailbox first.</a>";
		}else{
			$html += "<a href='#' class='ok'>Ok, I'm ready to start sharing.</a>";
		}
		$html += '</div>';
		
		return $soupmail.modal.raise($html, '', 'help_save_email');
	}
	
};

$soupmail.notification = {
	
	enabled : true,
	
	error : function($error, $heading) {
		if ($heading) {
			$error = $heading + ': ' + $error;
		}
		$soupmail.testFailure($error);
		return $soupmail.notification.raise($error, 'error');
	},
	
	notice : function($notice) {
		return $soupmail.notification.raise($notice, 'notice');
	},
	
	message : function($message) {
		return $soupmail.notification.raise($message, 'message');
	},
	
	versionUpdate : function($message, $url, $version) {
		if ($config.mobile) {
			$views.all.scrollToTop();
		}
		if (jQuery('#version-update-bar').size() > 0) {
			jQuery('#version-update-bar').remove();
		}
		jQuery('body').prepend('<div id="version-update-bar"><div class="bar-message"></div><div class="bar-close"></div></div>');
		jQuery('#version-update-bar .bar-message').text($message);
		if ($url) {
			jQuery('#version-update-bar .bar-message').wrapInner('<a href="'+$url+'" target="_blank"></a>');
		}
		jQuery('#version-update-bar').show();
		jQuery('#header').animate({top:30}, 'slow');
		jQuery('html').animate({paddingTop:80}, 'slow', function() {
			jQuery('html').addClass('version-update-bar-visible');
			$views.main.resizeLHScolumn();
		});
		jQuery('#version-update-bar .bar-close').attr('data-version', $version);
		jQuery('#version-update-bar .bar-close').click(function() {
			jQuery('#header').animate({top:0}, 'slow');
			jQuery('html').animate({paddingTop:50}, 'slow', function() {
				jQuery('#version-update-bar').remove();
				jQuery('html').removeClass('version-update-bar-visible');
				$views.main.resizeLHScolumn();
			});
			$controllers.all.acceptUIversion( jQuery(this).attr('data-version') );
		});
	},
	
	raise : function($message, $type) {
		
		if (!$soupmail.notification.enabled) {
			return false;
		}
		if ($type == null) {
			$type = 'error';
		}
		if ($config.mobile) {
			$views.all.scrollToTop();
		}
		if (jQuery('#message-bar').size() == 0) {
			jQuery('body').prepend('<div id="message-bar"></div>');
		}
		var $messageId = 'message_' + parseInt(Math.random() * 10000);
		var $messageIdSelector = '#'+$messageId;
		var timeToDisplay = ( ($type == 'error') ? 10000 : 7000 );
		jQuery('#message-bar').append('<div id="'+$messageId+'" class="'+$type+'">'+$message+'</div>');
		jQuery($messageIdSelector).slideDown('slow', function() {
			setTimeout('$soupmail.notification.remove("#'+jQuery(this).attr('id')+'")', timeToDisplay);
		});
		
	},
	
	remove : function($messageIdSelector) {
		jQuery($messageIdSelector).slideUp('slow');
	}
	
};

$soupmail.validator = function($config) {
	
	this.config = {
		selector : '#validation-input',
		validator : 'required',
		failMessage : 'Please ensure this field is filled in',
		autobind : true
	};
	
	this.destroy = destroy;
	this.getValue = getValue;
	this.validOrError = validOrError;
	this.validate = validate;
	this.validateRequired = validateRequired;
	this.validateIMAPcompatible = validateIMAPcompatible;
	this.validateEmail = validateEmail;
	this.validatePasswordLength = validatePasswordLength;
	this.validatePasswordMixedCase = validatePasswordMixedCase;
	this.validatePasswordAlphanumeric = validatePasswordAlphanumeric;
	this.validatePassword = validatePassword;
	
	if ($config) {
		var validator = this;
		jQuery.each($config, function($key, $val) {
			validator.config[$key] = $val;
		});
	}
	
	if (this.config.autobind) {
		jQuery(this.config.selector).on('keyup', jQuery.proxy(this, 'validate'));
		jQuery(this.config.selector).on('change', jQuery.proxy(this, 'validate'));
		jQuery(this.config.selector).on('focus', jQuery.proxy(this, 'validate'));
		jQuery(this.config.selector).on('blur', jQuery.proxy(this, 'validate'));
	}
	
	jQuery(this.config.selector).attr('rel', 'tipsy-manual');
	jQuery(this.config.selector).tipsy({trigger: 'manual'});
	
	function destroy() {
		jQuery(this.config.selector).tipsy('hide');
		jQuery(this.config.selector).off('keyup');
		jQuery(this.config.selector).off('change');
		jQuery(this.config.selector).off('focus');
		jQuery(this.config.selector).off('blur');
		jQuery('.tipsy').remove();
	};
	
	function getValue() {
		return jQuery(this.config.selector).val();
	};
	
	function validOrError(message) {
		var isValid = this.validate();
		var message = (message ? message : this.config.failMessage);
		if (!isValid) {
			jQuery(this.config.selector).tipsy('hide');
			$soupmail.modal.error(message);
		}
		return isValid;
	};
	
	function validate() {
		var func = 'validate' + this.config.validator;
		if (jQuery(this.config.selector).is(':focus') && !this.getValue()) {
			jQuery(this.config.selector).tipsy('hide');
			return true;
		}
		if (this[func]) {
			var isValid = this[func].apply(this, [this.getValue()]);
			if (!isValid) {
				jQuery(this.config.selector).attr('title', this.config.failMessage);
				jQuery(this.config.selector).tipsy('show');
			} else {
				jQuery(this.config.selector).tipsy('hide');
			}
			return isValid;
		} else {
			console.error('Validation not possible: validation function "'+func+'" does not exist');
		}
	};
	
	function validateRequired(value) {
		return ((value != '') ? true : false);
	};
	
	function validateIMAPcompatible(value) {
		if (!value) {
			return false;
		}
		if ((value.indexOf('.') >= 0) || (value.indexOf('/') >= 0)) {
			return false;
		}
		return true;
	};
	
	function validateEmail(value) {
		if (!value) {
			return false;
		}
		// http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
		// We get a more practical implementation of RFC 2822 if we omit the syntax using double quotes and square brackets. It will still match 99.99% of all email addresses in actual use today.
		var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
		if (regex.test(value)) {
			return true;
		} else {
			return false;
		}
	};
	
	function validatePasswordLength(value) {
		if (value.length >= 8) {
			return true;
		} else {
			return false;
		}
	};
	
	function validatePasswordMixedCase(value) {
		if (/^(?=.*[a-z])(?=.*[A-Z])/.test(value)) {
			return true;
		} else {
			return false;
		}
	};
	
	function validatePasswordAlphanumeric(value) {
		if (/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(value)) {
			return true;
		} else {
			return false;
		}
	};
	
	function validatePassword(value) {
		if (this.validatePasswordLength(value) && this.validatePasswordMixedCase(value) && this.validatePasswordAlphanumeric(value)) {
			return true;
		} else {
			return false;
		}
	};
	
};

$soupmail.sidetip = {
	
	validatePassword : function() {
		// Validate length				
		if (jQuery('#password').val().length >= 8){
			jQuery('.password .error.length').hide();
		} else {
			jQuery('.password .error.length').show();
		}
		
		// Validate mixed case
		if (/^(?=.*[a-z])(?=.*[A-Z])/.test(jQuery('#password').val())){
			jQuery('.password .error.case').hide();
		} else {
			jQuery('.password .error.case').show();
		}
		
		// Validate alphanumeric
		if (/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(jQuery('#password').val())){
			jQuery('.password .error.alphanumeric').hide();
		} else {
			jQuery('.password .error.alphanumeric').show();
		}
		
		if ((jQuery('#password').val().length >= 8) && (/^(?=.*[a-z])(?=.*[A-Z])/.test(jQuery('#password').val())) && (/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(jQuery('#password').val()))){
			jQuery('.password .ok').show();
			if (jQuery('#password2').val() != ''){
				if (jQuery('#password').val() != jQuery('#password2').val()){
					jQuery('.password2 .error').show();
					jQuery('.password2 .ok').hide();
				} else {
					jQuery('.password2 .error').hide();
					jQuery('.password2 .ok').show();
				}
			} else {
				jQuery('.password2 .error').hide();
				jQuery('.password2 .ok').hide();
			}
		} else {
			jQuery('.password .ok').hide();
		}
	},
	
	validatePassword2 : function() {
		// Validate confirm password
		if (this.timer) clearTimeout(this.timer);
		this.timer = setTimeout(function () {
			if (jQuery('#password2').val() != ''){
				if (jQuery('#password').val() != jQuery('#password2').val()){
					jQuery('.password2 .error').show();
					jQuery('.password2 .ok').hide();
				} else {
					jQuery('.password2 .error').hide();
					jQuery('.password2 .ok').show();
				}
			} else {
				jQuery('.password2 .error').hide();
				jQuery('.password2 .ok').hide();
			}
		}, 500);
	},
	
	validateEmail : function() {
		// Validate email address
		if (this.timer) clearTimeout(this.timer);
		this.timer = setTimeout(function () {
			var validator = new $soupmail.validator();
			if (validator.validateEmail(jQuery('#email').val())) {
				jQuery('.email .error').hide();
				jQuery('.email .ok').show();
			} else {
				jQuery('.email .error').hide();
				jQuery('.email .ok').hide();	
			}
		}, 500);
	}
	
};


// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.errors.js